export const blogPosts = [
  {
    id: '1',
    slug: 'advanced-threat-detection-ai-cybersecurity',
    title: 'Advanced Threat Detection: How AI is Revolutionizing Cybersecurity in 2026',
    excerpt: 'Discover how next-generation artificial intelligence and machine learning are transforming threat detection, enabling organizations to identify and neutralize cyber attacks in real time.',
    category: 'Cybersecurity',
    author: {
      name: 'Sarah Chen',
      avatar: 'https://public.readdy.ai/ai/img_res/a989a8a84bcf06d2f38564a696a15bbf.jpg'
    },
    date: '2026-05-18',
    readTime: '8 min read',
    coverImage: 'https://readdy.ai/api/search-image?query=futuristic%20cybersecurity%20AI%20threat%20detection%20interface%20with%20holographic%20data%20visualization%20neural%20networks%20and%20digital%20security%20patterns%20on%20dark%20blue%20technological%20background&width=800&height=400&seq=blog1&orientation=landscape',
    featured: true
  },
  {
    id: '2',
    slug: 'cloud-security-best-practices-2026',
    title: 'Cloud Security Best Practices for Enterprise Organizations in 2026',
    excerpt: 'A comprehensive guide to implementing robust cloud security strategies, covering zero-trust architecture, identity management, and the latest compliance frameworks.',
    category: 'Cloud',
    author: {
      name: 'Michael Rodriguez',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20cloud%20architect%20man%20with%20beard%20wearing%20navy%20blue%20shirt%20in%20modern%20tech%20office%20with%20clean%20white%20background&width=64&height=64&seq=author2&orientation=squarish'
    },
    date: '2026-05-12',
    readTime: '12 min read',
    coverImage: 'https://readdy.ai/api/search-image?query=cloud%20computing%20security%20architecture%20with%20shield%20icons%20lock%20symbols%20and%20data%20protection%20elements%20floating%20above%20server%20infrastructure%20on%20light%20blue%20gradient%20background&width=800&height=400&seq=blog2&orientation=landscape'
  },
  {
    id: '3',
    slug: 'machine-learning-predictive-analytics-business',
    title: 'Leveraging Machine Learning for Predictive Analytics in 2026 Business Intelligence',
    excerpt: 'Learn how organizations are using cutting-edge machine learning algorithms to predict market trends, optimize operations, and make data-driven decisions that drive growth.',
    category: 'AI & Analytics',
    author: {
      name: 'Dr. Emily Watson',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20data%20scientist%20woman%20with%20glasses%20wearing%20white%20blazer%20in%20modern%20analytics%20office%20with%20clean%20neutral%20background&width=64&height=64&seq=author3&orientation=squarish'
    },
    date: '2026-04-30',
    readTime: '10 min read',
    coverImage: 'https://readdy.ai/api/search-image?query=machine%20learning%20predictive%20analytics%20dashboard%20with%20colorful%20data%20charts%20graphs%20neural%20network%20visualization%20and%20business%20intelligence%20metrics%20on%20clean%20white%20background&width=800&height=400&seq=blog3&orientation=landscape'
  },
  {
    id: '4',
    slug: 'digital-transformation-roadmap-enterprise-2026',
    title: 'Building a Successful Digital Transformation Roadmap for Enterprise in 2026',
    excerpt: 'Strategic insights on planning and executing digital transformation initiatives that align technology investments with business objectives and evolving organizational culture.',
    category: 'Digital Strategy',
    author: {
      name: 'James Thompson',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20strategist%20man%20with%20gray%20hair%20wearing%20dark%20suit%20in%20executive%20boardroom%20with%20modern%20clean%20background&width=64&height=64&seq=author4&orientation=squarish'
    },
    date: '2026-04-22',
    readTime: '15 min read',
    coverImage: 'https://readdy.ai/api/search-image?query=digital%20transformation%20roadmap%20concept%20with%20interconnected%20technology%20icons%20business%20processes%20and%20strategic%20planning%20elements%20on%20gradient%20background&width=800&height=400&seq=blog4&orientation=landscape'
  },
  {
    id: '5',
    slug: 'zero-trust-network-security-implementation-2026',
    title: 'Implementing Zero Trust Network Security in 2026: A Step-by-Step Guide',
    excerpt: 'Practical guidance on transitioning from traditional perimeter-based security to a comprehensive zero trust architecture that protects modern distributed workforces.',
    category: 'Cybersecurity',
    author: {
      name: 'Alex Kumar',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20network%20security%20specialist%20man%20with%20short%20black%20hair%20wearing%20blue%20shirt%20in%20cybersecurity%20operations%20center%20with%20clean%20technical%20background&width=64&height=64&seq=author5&orientation=squarish'
    },
    date: '2026-04-10',
    readTime: '11 min read',
    coverImage: 'https://readdy.ai/api/search-image?query=zero%20trust%20network%20security%20concept%20with%20shield%20barriers%20identity%20verification%20and%20network%20protection%20elements%20on%20dark%20technological%20background&width=800&height=400&seq=blog5&orientation=landscape'
  },
  {
    id: '6',
    slug: 'multi-cloud-strategy-cost-optimization-2026',
    title: 'Multi-Cloud Strategy in 2026: Optimizing Costs and Performance Across Providers',
    excerpt: 'Explore the latest strategies for managing multiple cloud providers effectively, including cost optimization techniques, vendor lock-in prevention, and performance monitoring.',
    category: 'Cloud',
    author: {
      name: 'Lisa Park',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20cloud%20solutions%20architect%20woman%20with%20long%20brown%20hair%20wearing%20teal%20blazer%20in%20modern%20tech%20office%20with%20clean%20minimal%20background&width=64&height=64&seq=author6&orientation=squarish'
    },
    date: '2026-03-28',
    readTime: '9 min read',
    coverImage: 'https://readdy.ai/api/search-image?query=multi-cloud%20architecture%20diagram%20with%20different%20cloud%20provider%20logos%20connected%20networks%20and%20cost%20optimization%20charts%20on%20light%20gradient%20background&width=800&height=400&seq=blog6&orientation=landscape'
  },
  {
    id: '7',
    slug: 'ai-automation-workflow-optimization-2026',
    title: 'AI-Powered Automation in 2026: Streamlining Business Workflows for Maximum Efficiency',
    excerpt: 'Discover how intelligent automation and AI-driven workflows are helping organizations reduce manual processes, minimize errors, and accelerate business operations this year.',
    category: 'AI & Analytics',
    author: {
      name: 'Robert Kim',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20automation%20engineer%20man%20with%20mustache%20wearing%20charcoal%20sweater%20in%20modern%20AI%20lab%20with%20clean%20futuristic%20background&width=64&height=64&seq=author7&orientation=squarish'
    },
    date: '2026-03-15',
    readTime: '7 min read',
    coverImage: 'https://readdy.ai/api/search-image?query=AI%20automation%20workflow%20diagram%20with%20robotic%20process%20automation%20gears%20interconnected%20systems%20and%20efficiency%20metrics%20on%20clean%20white%20technological%20background&width=800&height=400&seq=blog7&orientation=landscape'
  },
  {
    id: '8',
    slug: 'customer-experience-digital-innovation-2026',
    title: 'Transforming Customer Experience Through Digital Innovation and Data Analytics in 2026',
    excerpt: 'Learn how leading organizations leverage the latest digital technologies, personalization algorithms, and customer data platforms to deliver exceptional user experiences.',
    category: 'Digital Strategy',
    author: {
      name: 'Maria Gonzalez',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20customer%20experience%20strategist%20woman%20with%20curly%20hair%20wearing%20purple%20blouse%20in%20modern%20customer%20service%20center%20with%20clean%20professional%20background&width=64&height=64&seq=author8&orientation=squarish'
    },
    date: '2026-03-05',
    readTime: '13 min read',
    coverImage: 'https://readdy.ai/api/search-image?query=customer%20experience%20transformation%20concept%20with%20user%20journey%20mapping%20digital%20touchpoints%20and%20satisfaction%20metrics%20on%20soft%20gradient%20background&width=800&height=400&seq=blog8&orientation=landscape'
  }
];

export const categories = [
  'All',
  'Cybersecurity',
  'Cloud',
  'AI & Analytics',
  'Digital Strategy'
];
